import {
  organizationProjectListVariants,
  organizationProjectMessageVariants,
  organizationProjectSkeletonVariants,
} from '@/features/organization-project-picker/config/organizationTree';
import type {
  OrganizationTreeDensity,
  OrganizationTreeRow,
} from '@/features/organization-project-picker/types/organizationTree';
import { Skeleton } from '@/shared/components/ui/skeleton';
import { Trans, useLingui } from '@lingui/react/macro';
import type { CSSProperties, Ref } from 'react';

export function OrganizationTreeProjectStateRow({
  state,
  density,
  edge,
  onRetry,
  measureRef,
  virtualIndex,
  style,
}: {
  state: Extract<OrganizationTreeRow, { kind: 'project-state' }>['state'];
  density: OrganizationTreeDensity;
  edge: Extract<OrganizationTreeRow, { kind: 'project-state' }>['edge'];
  onRetry: () => void;
  measureRef?: Ref<HTMLLIElement>;
  virtualIndex: number;
  style: CSSProperties;
}) {
  const { t } = useLingui();

  return (
    <li ref={measureRef} data-index={virtualIndex} style={style}>
      <div className={organizationProjectListVariants({ density, edge })}>
        {state === 'pending' ? (
          <div aria-label={t`Loading projects`}>
            <Skeleton className={organizationProjectSkeletonVariants({ density })} />
            <Skeleton className={organizationProjectSkeletonVariants({ density })} />
          </div>
        ) : state === 'failed' ? (
          <div className={organizationProjectMessageVariants({ tone: 'destructive', density })}>
            <button type="button" onClick={onRetry} className="underline-offset-2 hover:underline">
              <Trans>Couldn’t load projects — retry</Trans>
            </button>
          </div>
        ) : (
          <div className={organizationProjectMessageVariants({ tone: 'muted', density })}>
            <Trans>No projects</Trans>
          </div>
        )}
      </div>
    </li>
  );
}
